module.exports = __webpack_public_path__ + "img/sweatshirt-white-01.7da69e05.jpg";